import {
    convertUniversalDateTimeToPersianDateTime,
    DialogSize,
    RaikoBaseCardContainer,
    RaikoBaseContainer,
    RaikoBreadcrumb,
    raikoBreadCrumbItemGenerator,
    RaikoCustomTable,
    RaikoGridOneColumn,
    RaikoTableTitleContainer,
    showErrorMessage, RaikoDefaultDialogPage, addNewRowToTable
} from "@moeindal/base-raiko-panel-components";
import {RouteHelper} from "../../route/RouteHelper";
import React, {useEffect, useState} from "react";
import {MagazineSliderService} from "../../serverService/magazineService/MagazineSliderService";
import {detectServerErrorMessage} from "../../util/detectServerErrorMessage";
import SliderAddNewSlide from "./SliderAddNewSlide";
import {useNavigate} from "react-router-dom";

export default function Sliders() {

    const size = 25
    let page = 0

    const service = new MagazineSliderService()

    const [totalItems, setTotalItems] = useState("")
    const [sliders, setSliders] = useState([]);
    const [tableLoading, setTableLoading] = useState(false)
    const [pageCount, setPageCount] = useState(0);

    const navigate = useNavigate()

    useEffect(() => {
        getDataFromServer()
    }, []);


    function handleChangePagination(newPage) {
        page = newPage
        getDataFromServer()
    }

    function getDataFromServer() {
        setTableLoading(true)
        service.getSliders(
            page, size
        ).then(response => {
            setTotalItems(response.numberOfItems)
            setPageCount(response.totalPage)

            setSliders([])
            response.data.map((item, index) => {
                setSliders(prev => [
                    ...prev,
                    prepareSliderItem(
                        item.id,
                        (page * size) + index + 1,
                        item.title,
                        item.postedAt,
                        item.enabled
                    )
                ])
            })

        }).catch(reason => {
            showErrorMessage(detectServerErrorMessage(reason))
        }).finally(_ => {
            setTableLoading(false)
        })
    }

    function prepareSliderItem(id, number, title, postedAt, enabled) {
        return {
            id,
            number,
            title,
            postedAt: convertUniversalDateTimeToPersianDateTime(postedAt)
        }
    }

    function handleSelectRow(_item) {
        let _title = ""
        sliders.map((item) => {
            if (item.id === _item)
                _title = item.name
        })

        navigate(
            RouteHelper.MagazineSliderDetail.globalUrl.replace(":id", _item),
            {state: {title: _title}, replace: false}
        )
    }

    const [openDialog, setOpenDialog] = useState(false)

    const handleOpenDialog = () => setOpenDialog(true)
    const handleCloseDialog = () => setOpenDialog(false)

    function addNewSliderToTable(item) {
        const newSliders = addNewRowToTable(
            prepareSliderItem(
                item.id,
                1,
                item.title,
                item.postedAt,
                item.enabled
            ),
            sliders
        )


        setSliders(newSliders)
        handleCloseDialog()
    }

    return (
        <>
            <RaikoDefaultDialogPage
                onClose={handleCloseDialog}
                open={openDialog}
                pageTitle={"افزودن اسلاید جدید"}
                dialogSize={DialogSize.LARGE}
            >
                <SliderAddNewSlide addNewSliderToTable={addNewSliderToTable}/>
            </RaikoDefaultDialogPage>

            <RaikoBaseContainer>
                <RaikoBreadcrumb breadCrumbItems={[
                    raikoBreadCrumbItemGenerator(
                        RouteHelper.Magazine.name,
                        ""
                    ),
                    raikoBreadCrumbItemGenerator(
                        RouteHelper.MagazineSlider.name,
                        RouteHelper.MagazineSlider.url
                    )
                ]}/>
                <RaikoBaseCardContainer>
                    <RaikoGridOneColumn>
                        <RaikoTableTitleContainer
                            title={"اسلایدر"}
                            amount={totalItems}
                            hasCreateNewItem
                            handleCreateNewItem={handleOpenDialog}
                        />
                        <RaikoCustomTable
                            header={header}
                            data={sliders}
                            isLoading={tableLoading}
                            newPage={page}
                            pageCount={pageCount}
                            handlePaginationChange={handleChangePagination}
                            rowClicked={handleSelectRow}
                        />
                    </RaikoGridOneColumn>
                </RaikoBaseCardContainer>
            </RaikoBaseContainer>
        </>
    )
}


const header = [
    {
        id: "number",
        label: "#"
    }, {
        id: "title",
        label: "عنوان"
    }, {
        id: "postedAt",
        label: "تاریخ"
    },
]
